import { css } from 'linaria';

export const cartButton = css`
  margin-top: auto;
  background-color: var(--control-primary) !important;

  &:hover {
    background-color: var(--control_hover-primary) !important;
  }
`;

export const imageBaseWrapper = css`
  position: relative;
  flex-shrink: 0;
  width: 132px;
  height: 132px;

  @media (--to-desktop) {
    width: 104px;
    height: 104px;
  }
`;

export const simplifiedImageWrapper = css`
  position: relative;
  flex-shrink: 0;
  width: 131px;
  height: 131px;
`;

export const productBaseWrapperSimplified = css`
  display: flex;
  flex-direction: column;
  gap: var(--space-125);
  height: 100%;
  padding: var(--space-200);
  background-color: var(--background-primary);
  border-radius: 12px;
  align-items: center;
`;
